import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs';
import {LocationStrategy} from '@angular/common';
import {Injectable, Self} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BasicDataService} from './basicData.service';
import {LoggerService} from '../logger.service';
import {DataRequestOptions, PollResponse, PollResultsResponse, QuestionsResponse} from '../../models';
import * as _ from "underscore";

@Injectable()
export class TakerDataService extends BasicDataService {

    constructor(@Self() protected http: HttpClient,
                protected locationStrategy: LocationStrategy,
                protected logger: LoggerService) {
        super(http, locationStrategy, logger);
    }

    public getPoll(pollId: number, scriptId: string, options: DataRequestOptions): Observable<PollResponse> {
        this.logger.log('TakerDataService: getPoll', pollId);

        const url = this.POLL_SERVICE_URL + 'taker/' + (options.anonymous ? 'openPoll/' : 'poll/') + pollId +
            (this.isBaseUrl() ?
                '/get_' + pollId + '_' + scriptId + '.json' :
                '/get.json' + (scriptId !== null ? '?scriptId=' + scriptId : ''));

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<PollResponse>(url, {headers: headers});
    }

    public startPoll(pollId: number, options: DataRequestOptions, scriptId?: string): Observable<QuestionsResponse> {
        this.logger.log('TakerDataService: start', pollId, scriptId);

        const url = this.POLL_SERVICE_URL + 'taker/' + (options.anonymous ? 'openPoll/' : 'poll/') + pollId +
            (this.isBaseUrl() ?
                '/start_' + pollId
                + (scriptId ? '_' + scriptId : '') + '.json'
                + (scriptId ? '?scriptId=' + scriptId : '') :
                '/start.json'
                + (scriptId ? '?scriptId=' + scriptId : ''));

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<QuestionsResponse>(url, {headers: headers});
    }

    public getQuestions(pollId: number, options: DataRequestOptions, scriptId: string, questSetNum?: number): Observable<QuestionsResponse> {
        this.logger.log('TakerDataService: getQuestions', pollId, scriptId, questSetNum);

        const url = this.POLL_SERVICE_URL + 'taker/' + (options.anonymous ? 'openPoll/' : 'poll/') + pollId +
            (this.isBaseUrl() ?
                '/questions_' + pollId
                + (scriptId ? '_' + scriptId : '')
                + (questSetNum ? '_' + questSetNum : '')
                + '.json' :
                '/questions.json'
                + '?scriptId=' + scriptId);

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<QuestionsResponse>(url, {headers: headers});
    }

    public submit(obj: any, pollId: number, options: DataRequestOptions, scriptId: string, questSetNum: number,
                  submitAndNext: boolean): Observable<QuestionsResponse> {

        this.logger.log('TakerDataService: submit', pollId, scriptId, questSetNum, submitAndNext, obj);

        if (this.isBaseUrl()) {
            return this.getQuestions(pollId, options, scriptId, questSetNum);
        }

        let params = new HttpParams();
        params = params.append('commit', String(submitAndNext));

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        const url = this.POLL_SERVICE_URL + 'taker/' + (options.anonymous ? 'openPoll/' : 'poll/') + pollId + '/submit.json';

        return this.http.post<QuestionsResponse>(url, obj, {headers: headers, params: params});
    }

    public getPollResults(pollId: number, options: DataRequestOptions): Observable<PollResultsResponse> {

        this.logger.log('TakerDataService: getPollResults', pollId, options.anonymous);

        const url = this.isBaseUrl() ?

            this.POLL_SERVICE_URL + 'taker/' + (options.anonymous ? 'openPoll/' : 'poll/') + pollId
            + '/results_' + pollId + '.json' :
            this.POLL_SERVICE_URL + 'taker/poll/' + pollId + '/results.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<PollResultsResponse>(url, {headers: headers});
    }

    public getDownloadUrl(isTaker: boolean, pollId: number, rawDataOnly: boolean,
                          respondentEmails: boolean, respondentIds: boolean, respondentHUID: boolean,
                          includeAllParticipants: boolean, nonRespondents: boolean,
                          suppressDescriptions: boolean, questionTextInColumn/*not used*/: boolean): string {

        const url = this.POLL_SERVICE_URL + (isTaker ? 'taker/poll/' + pollId + '/download' :
            'author/results/' + pollId + '/download');
        return url
            + '?rawDataOnly=' + rawDataOnly
            + '&suppressDescriptions=' + suppressDescriptions
            + '&respondentEmails=' + respondentEmails
            + '&respondentIds=' + respondentIds
            + (respondentHUID ? '&respondentHUID=' + respondentHUID : '')
            + (includeAllParticipants ? '&includeAllParticipants=' + includeAllParticipants : '')
            + (nonRespondents ? '&nonRespondents=' + nonRespondents : '');

    }
}
